import React, { useEffect, useRef, useState } from "react";
import { icons } from "../../assets/icons";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useGenerateMenuActivities } from "../../hooks/useGenerateMenuActivities";
import { useRouterDetectNavigation } from "../../hooks/useRouterDetectNavigation";
import { changueReturnHome } from "../../store/slices/menu/menu";
import { audiosAssets } from "../../assets/audio";

export const ActivitiesMenu = () => {
	const { activitiesInformation, returnHome } = useSelector((state) => state.menu);
	const dispatch = useDispatch()
	const { menuGenerate, selectTopic, selectedTopic, selectSubTopic, selectedSubTopic, getSubTopicChange, getActivitiesBySubTopic } =
		useGenerateMenuActivities(activitiesInformation, returnHome);
	const navigateRoute = useRouterDetectNavigation(activitiesInformation);

	const [visibleMenuItems, setvisibleMenuItems] = useState(true);
	const menuref = useRef(null);

	useEffect(() => {
		ObserverEmitter.on(EVENTS.hiddenMenusAnimations, () => {
			// TODO: diparar la aniacion y despues desparecer
			// menuref.current.classList.remove("animate__fadeInRight");
			// menuref.current.classList.add("animate__fadeOutRight");
			setvisibleMenuItems(false);
		});
		ObserverEmitter.on(EVENTS.showMenuAnimations, () => {
			// menuref.current.classList.remove("animate__fadeOutRight");
			// menuref.current.classList.add("animate__fadeInRight");
			setvisibleMenuItems(true);
		});
	}, []);

	if (!visibleMenuItems) {
		return <></>;
	}

	return (
		<div ref={menuref} className="w-full h-full overflow-y-scroll hidden-scrooll animate__animated animate__fadeInRight pl-4">
			<div className="w-full md:h-[90%]">
				{/* 50px */}
				<NameRowTeam name="Temas cursados" init={menuGenerate.topicsCovered} finish={menuGenerate.totalTeams} />
				{/* 80px */}
				<MenuTopicsSelect topics={menuGenerate.topicsToTake} actionMove={(value) => selectTopic(value)} selectTopic={selectedTopic} />
				{/* 255px */}
				<SubTopicSelect
					subTopics={getSubTopicChange}
					selectSubTopic={selectSubTopic}
					actionMove={(value) => {
						selectedSubTopic(value);
					}}
				/>
				{/* 50px */}
				<NameRowTeam name="Actividades completadas" init={getActivitiesBySubTopic.completes} finish={getActivitiesBySubTopic.total} />{" "}
				{/* 	height: calc(100% - 435px) */}
				<AcvitiesView activities={getActivitiesBySubTopic.activities} />
			</div>
			<div className="overflow-hidden h-[40px] md:h-[10%]">
				<div className="w-full h-full  justify-center items-center hidden md:flex">
					<button
						onClick={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
							// navigator(navigateRoute);
							window.location.href = navigateRoute;
							dispatch(changueReturnHome(false))
							// navigator("introduction");
						}}
						className="bg-yellow_primary h-10 w-[256px] rounded-xl text-white text-[20px] font-bold"
					>
						Continuar curso
					</button>
				</div>
			</div>
		</div>
	);
};

const NameRowTeam = ({ name = "", init = 0, finish = 0 }) => {
	return (
		<div className="overflow-hidden flex items-center gap-4 text-white pl-4 h-[50px]">
			<div>
				<img src={icons.book} alt="libro" />
			</div>
			<div className="">
				<span>{name}</span>
			</div>
			<div>
				<span>
					{init} de {finish}
				</span>
			</div>
		</div>
	);
};

const MenuTopicsSelect = ({ selectTopic = 1, topics = [], actionMove = () => { } }) => {
	// selectTopic === topic.id
	return (
		<>
			<div className="h-[80px] scrooll-horizontal-menu w-full  overflow-x-auto grid grid-flow-col items-center gap-4">
				{topics.map((topic, index) => {
					let selectTypeStyle = {
						styles: "bg-gray_block text-gray_text_block ",
						icon: icons.padlocks,
					};
					if (topic.isCompleteTopic === 1) {
						selectTypeStyle = {
							styles: "bg-white text-orange-300",
							icon: icons.threepoints,
						};
					}
					if (topic.isCompleteTopic === 2) {
						selectTypeStyle = {
							styles: "bg-green_primary text-white",
							icon: icons.arrowmenu,
						};
					}
					return (
						<div
							onClick={() => {
								actionMove(topic.id);
							}}
							key={`${index}-topic-team`}
							className={`rounded-lg pl-2 pr-4 py-2 whitespace-nowrap flex justify-center  items-center gap-4 ${selectTypeStyle.styles}`}
						>
							<div className="h-5 w-5">
								<img className="h-full w-full object-contain" src={selectTypeStyle.icon} alt="icon" />
							</div>
							<span className={``}>{topic.titleTopic}</span>
						</div>
					);
				})}
			</div>
		</>
	);
};

const SubTopicSelect = ({ subTopics = [], selectSubTopic = 1, actionMove = () => { } }) => {
	// selectSubTopic === index
	return (
		<>
			<div className="h-[255px] scrooll-horizontal-menu w-full overflow-x-auto py-2 flex items-center gap-4">
				{subTopics.map((subTopic, index) => {

					// nada
					let selectTypeStyle = {
						container: "bg-[#505050]",
						titleStyle: "text-white",
						textStyle: "text-white",
						select: "border-white",
						notSelect: "border-[#505050]"
					};
					// proceso
					if (subTopic.isCompleteSubtopic === 1) {

						selectTypeStyle = {
							container: "bg-white",
							titleStyle: "text-orange_primary",
							textStyle: "text-black",
							select: "border-[#FFC427]",
							notSelect: "border-white"
						};
					}
					// correcta
					if (subTopic.isCompleteSubtopic === 2) {

						selectTypeStyle = {
							container: "bg-green_primary",
							titleStyle: "text-white",
							textStyle: "text-white",
							select: "border-white",
							notSelect: "border-green_primary"
						};
					}
					// fallida
					if (subTopic.isCompleteSubtopic === 3) {
						selectTypeStyle = {
							container: "bg-[#DF3C3C]",
							titleStyle: "text-white",
							textStyle: "text-white",
							select: "border-white",
							notSelect: "border-[#DF3C3C]"
						};
					}

					return (
						<div
							onClick={() => {
								if (subTopic.isCompleteSubtopic === 0) {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardTeamBlock)
								}
								if (subTopic.isCompleteSubtopic === 1) {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardProcess)

								}
								if (subTopic.isCompleteSubtopic === 2) {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardComplete)
								}
								actionMove(index);
							}}
							key={`${index}-subtopic-team`}
							className={`h-full`}
						>
							<div className={`whitespace-nowrap ${selectTypeStyle.container} w-[115px] rounded-xl border-[3px]  p-1  ${selectSubTopic === index ? selectTypeStyle.select : selectTypeStyle.notSelect}`}>
								<div className="overflow-hidden h-[32px]">
									<div className="h-full w-full text-center flex justify-center items-center whitespace-normal">
										<span className={`${selectTypeStyle.titleStyle} text-[8px] font-semibold`}>{subTopic.title}</span>
									</div>
								</div>
								<div className="h-[152px] overflow-hidden">
									{subTopic.isCompleteSubtopic === 0 ? (
										<>
											<div className="h-full w-full flex justify-center items-center">
												<div className="h-[60px] w-[60px] bg-[#cdcdcd] rounded-full border-[3px] bourder-[#cccccc] p-2">
													<img className="h-full w-full object-contain" src={icons.padlocks} alt="insignia" />
												</div>
											</div>
										</>
									) : (
										<>
											<div className="h-11 w-full overflow-hidden flex justify-center items-center">
												<div
													className={`${[1, 3].includes(subTopic.isCompleteSubtopic) ? "border-transparent" : "p-1 border-white"
														} border-[2px] rounded-full h-[40px] w-[40px]`}
												>
													<img
														className="h-full w-full object-contain"
														src={[1, 3].includes(subTopic.isCompleteSubtopic) ? 1 === subTopic.isCompleteSubtopic ? icons.iconnottask : icons.blackerrornotask : icons.insig}
														alt="insignia"
													/>
												</div>
											</div>
											<div className="text-center">
												<span className={`${selectTypeStyle.textStyle} text-[10px]`}>Puntos</span>
											</div>
											<div className="text-center ">
												<span className={`${selectTypeStyle.textStyle} text-[15px]`}>
													{subTopic.totalPointsWon}/{subTopic.points}
												</span>
											</div>
											<div className="text-center">
												<span className={`${selectTypeStyle.textStyle} text-[10px]`}>Procentaje</span>
											</div>
											<div className="text-center">
												<span className={`${selectTypeStyle.textStyle} text-[15px]`}>{parseInt(subTopic.percentagePoints)}%</span>
											</div>
											<div className="mt-1">
												<div className="h-1 w-full bg-[#cccccc88] rounded-full overflow-hidden">
													<div
														className={`h-full ${subTopic.isCompleteSubtopic === 1 ? "bg-[#F59E0B]" : "bg-white"}`}
														style={{ width: `${subTopic.percentagePoints}%` }}
													/>
												</div>
											</div>
										</>
									)}
								</div>
							</div>
							<div className="text-center leading-none mt-1">
								<span className="text-[#cdcdcd] text-[10px]">Subtema {index + 1}</span>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
};

const AcvitiesView = ({ activities = [] }) => {
	return (
		<>
			{/* calculHeightMenu */}
			<div className="max-h-[calc(100%-435px)] w-full  overflow-x-auto scrooll-vertical-menu flex flex-wrap gap-4">
				{activities.map((activity, index) => {
					return (
						<div
							onClick={() => {
								if (activity.isOpen) {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardComplete)
								} else {
									ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.cards.cardTeamBlock)
								}
							}}
							key={`${index}-subtopic-team`}
							className={`h-[100px] w-[100px] bg-[#505050] text-white grid grid-rows-activityMenu p-2 rounded-lg overflow-hidden `}
						>
							<div className="overflow-hidden ">
								<span>Actividad {index + 1}</span>
							</div>
							<div className="flex flex-col justify-center items-center">
								{activity.isOpen ? (
									<>
										<div>
											<span>{parseInt(activity.percentagePoints)} %</span>
										</div>
										<div className="h-1 w-full bg-[#cccccc88] rounded-full overflow-hidden">
											<div
												className={`h-full ${activity.percentagePoints >= 100 ? "bg-[#22C55E]" : "bg-[#F59E0B]"}`}
												style={{ width: `${activity.percentagePoints}%` }}
											/>
										</div>
									</>
								) : (
									<>
										<div className="h-12 w-12 bg-[#EBF7F6] rounded-full border-[3px] bourder-[#cccccc] p-2">
											<img className="h-full w-full object-contain" src={icons.padlocks} alt="insignia" />
										</div>
									</>
								)}
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
};
